__turbopack_context__.v({
  "centeredAssetIcon": "lbUPMW_centeredAssetIcon",
  "dialogContainer": "lbUPMW_dialogContainer",
  "labelChip": "lbUPMW_labelChip",
  "labels": "lbUPMW_labels",
  "marker": "lbUPMW_marker",
  "markerPoint": "lbUPMW_markerPoint",
  "noTrackingData": "lbUPMW_noTrackingData",
});
